import {
  L_03,
  LOGO_STRIPS_DEFAULTS,
  hideLS03Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

const createCompanyLogoProp = (index) => ({
  type: "object",
  fields: {
    logoMobile: {
      type: "imageUrl",
    },
    logoTablet: {
      type: "imageUrl",
    },
    logoDesktop: {
      type: "imageUrl",
    },
    alt: {
      type: "string",
    },
  },
  defaultValue: {
    logoMobile: LOGO_STRIPS_DEFAULTS[L_03][`companyLogo${index}`],
    logoTablet: LOGO_STRIPS_DEFAULTS[L_03][`companyLogo${index}`],
    logoDesktop: LOGO_STRIPS_DEFAULTS[L_03][`companyLogo${index}`],
    alt: LOGO_STRIPS_DEFAULTS[L_03][`companyLogo${index}Alt`],
  },
  description: `Company logo ${index} (LS03 only)`,
  hidden: hideLS03Props,
});

export const LS03_PLASMIC_PROPS = {
  logoStripEyebrow: {
    type: "string",
    defaultValue: LOGO_STRIPS_DEFAULTS[L_03].logoStripEyebrow,
    description: "Eyebrow text above heading (LS03 only)",
    hidden: hideLS03Props,
  },
  logoStripHeading: {
    type: "string",
    defaultValue: LOGO_STRIPS_DEFAULTS[L_03].logoStripHeading,
    description: "Main heading (LS03 only)",
    hidden: hideLS03Props,
  },
  companyLogo1: createCompanyLogoProp(1),
  companyLogo2: createCompanyLogoProp(2),
  companyLogo3: createCompanyLogoProp(3),
  companyLogo4: createCompanyLogoProp(4),
  companyLogo5: createCompanyLogoProp(5),
  companyLogo6: createCompanyLogoProp(6),
  className: {
    type: "class",
    description: "Custom CSS class name for the section wrapper",
  },
};
